import { render, staticRenderFns } from "./LayoutRegister.vue?vue&type=template&id=879f042e&scoped=true"
import script from "./LayoutRegister.vue?vue&type=script&lang=js"
export * from "./LayoutRegister.vue?vue&type=script&lang=js"
import style0 from "./LayoutRegister.vue?vue&type=style&index=0&id=879f042e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879f042e",
  null
  
)

export default component.exports